export type FeatureAccessStatus = {
  code: string;
  reason: string | null;
  blocks: string[];
  status: 'blocked' | 'allowed';
};

export type FeatureAccessData = {
  anticipation: FeatureAccessStatus;
  transfer: FeatureAccessStatus;
};

export const defaultFeatureAccessStatus: FeatureAccessStatus = {
  code: '',
  blocks: [],
  status: 'blocked',
  reason: 'Ocorreu algum erro, tente novamente mais tarde',
};

export const USER_IN_BLACKLIST_ERROR_STATUS = 'BLK01';
